import styled from 'styled-components';

import { PALE_WHITE_1, WHITE } from '../../appearance/Colors';

export const MESSAGE_MENU_Z_INDEX = 10010;

export const DropDownMenu = styled.div`
    background: rgba(20, 24, 28, 0.96);
    border: 1px solid ${PALE_WHITE_1};
    min-height: 15px;
    min-width: 200px;
    max-width: 304px;
    z-index: 1500;
    color: ${WHITE};
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
    border-radius: 14px;
    overflow: hidden;
    backdrop-filter: saturate(180%) blur(24px);
    -webkit-backdrop-filter: saturate(180%) blur(24px);
`;

export const SeparatorLI = styled.li`
    padding-bottom: 1px;
    margin-bottom: 1px;
    border-bottom: 1px solid ${PALE_WHITE_1};
`;

export const Element = styled.div`
    padding: 10px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    &:hover {
        background-color: rgba(255, 255, 255, 0.08);
    }
`;

export const MenuItemLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const MenuItemIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.destructive ? '#ff7a7a' : 'rgba(255, 255, 255, 0.78)'};
`;

export const MenuItemSecondaryAction = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: rgba(255, 255, 255, 0.52);
    opacity: 0;
    pointer-events: none;
    cursor: pointer;
    transition: opacity 120ms ease, background-color 120ms ease, color 120ms ease;

    ${Element}:hover &,
    ${Element}:focus-within & {
        opacity: 1;
        pointer-events: auto;
    }

    &:hover {
        background-color: rgba(255, 255, 255, 0.08);
        color: rgba(255, 255, 255, 0.82);
    }
`;

export const DestructiveLabel = styled.span`
    color: #ff7a7a;
`;
